import { string, object } from 'yup';

import { transformEmptyStringToNull } from '@/utils/transformEmptyStringToNull';

const personStaffRelationshipField = (label: string) => {
  return string().notRequired().label(label).transform(transformEmptyStringToNull);
};

export const careTeamSectionSchema = object({
  case_manager_id: personStaffRelationshipField('Case Manager'),
  iop_counselor_id: personStaffRelationshipField('IOP Counselor'),
  member_advocate_id: personStaffRelationshipField('Member Advocate'),
  peer_supporter_id: personStaffRelationshipField('Peer Supporter'),
  primary_counselor_id: personStaffRelationshipField('Counselor'),
  recovery_goal: string().trim().notRequired().label('Recovery Goal'),
  treatment_consultant_id: personStaffRelationshipField('Treatment Consultant')
});
